import { render, staticRenderFns } from "./SCACreateSubscriptionPaymentRequestButton.vue?vue&type=template&id=1cfb47a5&scoped=true&"
import script from "./SCACreateSubscriptionPaymentRequestButton.vue?vue&type=script&lang=js&"
export * from "./SCACreateSubscriptionPaymentRequestButton.vue?vue&type=script&lang=js&"
import style0 from "./SCACreateSubscriptionPaymentRequestButton.vue?vue&type=style&index=0&id=1cfb47a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfb47a5",
  null
  
)

export default component.exports